export function applySortDirection(result, order) {
    return order === 'asc' ? result : -result;
}

export function compareStrings(a, b, locale = 'fi') {
    return String(a ?? '').localeCompare(String(b ?? ''), locale);
}

export function compareNumbers(a, b) {
    const aNumber = typeof a === 'number' ? a : null;
    const bNumber = typeof b === 'number' ? b : null;

    if (aNumber === null && bNumber === null) {
        return 0;
    }
    if (aNumber === null) {
        return 1;
    }
    if (bNumber === null) {
        return -1;
    }
    return aNumber - bNumber;
}

export function compareDates(a, b) {
    const aTime = a ? new Date(a).getTime() : Number.NaN;
    const bTime = b ? new Date(b).getTime() : Number.NaN;
    const aValid = !Number.isNaN(aTime);
    const bValid = !Number.isNaN(bTime);

    if (!aValid && !bValid) {
        return 0;
    }
    if (!aValid) {
        return 1;
    }
    if (!bValid) {
        return -1;
    }
    return aTime - bTime;
}
